import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import { Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

export default function FishingDepth(props) {
  const depthLabel = "Fishing depth in " + props.fishing_depth_uom;
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Fishing Depth</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              label={depthLabel}
              className="number-of-input"
              value={props.fishing_depth ? Number(props.fishing_depth) : ""}
              name="fishing_depth"
              type="number"
              min="0"
              max="999"
              onChange={(e) => props.handleInputChange(e)}
              helperText={depthLabel}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "depth")} />
        </Grid>
      </Grid>
    </Box>
  );
}
